












































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import XLine from './XLine.vue';
import YLine from './YLine.vue';
import ChartPoint from './ChartPoint.vue';
import PercentileLabel from '../PercentileLabel.vue';
@Component({
    components: {PercentileLabel, ChartPoint, YLine, XLine}
})
export default class WeightAgeChart extends Vue {
    @Prop({
        default: 'standard'
    })
    public unit!: string;

    @Prop({
        default: []
    })
    public entries!: any[];

    @Prop({
        default: '1'
    })
    public sex!: string;

    public points: any[] = [];

    public config: any = {
        standard: {
            // X = MONTHS
            xMin: 0,
            xMax: 24,
            xOffset: 0,
            xLength: 24,
            xIncrement: 1,

            // Y = LB
            yMin: 4,
            yMax: 36,
            yOffset: 3.08647,
            yLength: 33.51026,
            yIncrement: 1,
            xLines: [],
            yLines: []
        },
        metric: {
            // X = MONTHS
            xMin: 0,
            xMax: 24,
            xOffset: 0,
            xLength: 24,
            xIncrement: 1,

            // Y = KG
            yMin: 1.4,
            yMax: 16.6,
            yOffset: 1.4,
            yLength: 15.2,
            yIncrement: 0.2,
            xLines: [],
            yLines: []
        }
    }

    @Watch('unit')
    public onUnitChange(value: string, oldValue: string) {
        this.generateLines();
        this.generatePoints();
    }

    get lastMeasurementDate() {
        return this.entries[this.entries.length - 1].wt_len_meas_date
    }

    public generatePoints() {
        this.points = [];
        for (let i = 0; i < this.entries.length; i++) {
            if (this.entries[i].reliable) {
                if (this.unit === 'standard') {
                    const point = {
                        x: this.entries[i].wt_len_pt_age_months_nornd,
                        y: this.entries[i].patient_wt_lb,
                        age_weeks: this.entries[i].wt_len_pt_age_weeks,
                        age_months: this.entries[i].wt_len_pt_age_months,
                        label: i === this.entries.length - 1
                    };
                    if (point.x >= this.config.standard.xOffset && point.x <= this.config.standard.xOffset + this.config.standard.xLength &&
                        point.y >= this.config.standard.yOffset && point.y <= this.config.standard.yOffset + this.config.standard.yLength) {
                        this.points.push(point);
                    }
                }
                if (this.unit === 'metric') {
                    const point = {
                        x: this.entries[i].wt_len_pt_age_months_nornd,
                        y: this.entries[i].patient_wt_kg,
                        age_weeks: this.entries[i].wt_len_pt_age_weeks,
                        age_months: this.entries[i].wt_len_pt_age_months,
                        label: i === this.entries.length - 1
                    };
                    if (point.x >= this.config.metric.xOffset && point.x <= this.config.metric.xOffset + this.config.metric.xLength &&
                        point.y >= this.config.metric.yOffset && point.y <= this.config.metric.yOffset + this.config.metric.yLength) {
                        this.points.push(point);
                    }
                }
            }
        }
    }

    public generateLines() {

        this.config.standard.xLines = [];
        this.config.standard.yLines = [];

        this.config.metric.xLines = [];
        this.config.metric.yLines = [];

        if (this.unit === 'standard') {
            for (let i = this.config.standard.xMin; i <= this.config.standard.xMax; i+= this.config.standard.xIncrement) {
                this.config.standard.xLines.push({
                    value: i,
                    bold: i % 3 === 0,
                    label: i === 0 ? this.$t('GROWTH.CHARTS.BIRTH') : i,
                    showLabel: i % 3 === 0
                });
            }

            for (let i = this.config.standard.yMin; i <= this.config.standard.yMax; i+= this.config.standard.yIncrement) {
                this.config.standard.yLines.push({
                    value: i,
                    bold: i % 2 === 0,
                    label: i,
                    showLabel: i % 2 === 0
                });
            }
        }
        if (this.unit === 'metric') {
            for (let i = this.config.metric.xMin; i <= this.config.metric.xMax; i+= this.config.metric.xIncrement) {
                this.config.metric.xLines.push({
                    value: i,
                    bold: i % 3 === 0,
                    label: i === 0 ? this.$t('GROWTH.CHARTS.BIRTH') : i,
                    showLabel: i % 3 === 0
                });
            }

            for (let i = this.config.metric.yMin; i <= this.config.metric.yMax; i+= this.config.metric.yIncrement) {
                this.config.metric.yLines.push({
                    value: Math.round(i*10) / 10,
                    bold: Math.round(i*10) / 10 % 1 === 0,
                    label: Math.round(i),
                    showLabel: Math.round(i*10) / 10 % 1 === 0 && Math.round(i) !== 1 && Math.round(i) !== 17
                });
            }
        }
    }

    private mounted() {
        this.generateLines();
        this.generatePoints();
    }

}
